import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { I18nModule, Product } from '@spartacus/core';
import { CarouselComponent, IconModule, SpinnerModule, TabParagraphContainerModule } from "@spartacus/storefront";
import { GenProductTabReference } from 'src/app/generac/models/product.model';
import { GenSharedModule } from '../../shared.module';

@Component({
  selector: 'gen-carousel',
  templateUrl: './carousel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    I18nModule,
    IconModule,
    SpinnerModule,
    TabParagraphContainerModule,
    GenSharedModule
  ],
})
export class GenCarouselComponent extends CarouselComponent {
  activeTabIndex: number = 0;
  tabItems: Product[];
  tabReferences: GenProductTabReference[];
  @Input('tabReferences')
  set setTabReferences(inputItems: GenProductTabReference[]) {
    this.tabReferences = inputItems;
    this.selectTab(this.activeTabIndex);
  }
  @Input() viewAllLink: string;

  selectTab(index: number) {
    this.activeTabIndex = index;
    this.tabItems = this.tabReferences[this.activeTabIndex]?.products as Product[];
    this.activeSlide = 0;
  }
}
